/**
 * Shared display helpers for eBook activity cards (authoring + learner).
 */

/**
 * @param {{ ebook?: { title?: string|null } }|null|undefined} row
 * @returns {string}
 */
export function ebookDisplayTitle(row) {
    const t = row?.ebook?.title;
    if (typeof t === 'string' && t.trim() !== '') {
        return t.trim();
    }
    return 'Unknown';
}

/**
 * Deep-link subtitle is hidden when it duplicates the main title (case-insensitive).
 *
 * @param {{ ebook?: { title?: string|null }, deep_link_title?: string|null }|null|undefined} row
 * @returns {boolean}
 */
export function shouldShowDistinctDeepLinkTitle(row) {
    const deep = String(row?.deep_link_title ?? '').trim();
    const title = String(row?.ebook?.title ?? '').trim();
    if (!deep) {
        return false;
    }
    if (!title) {
        return true;
    }
    return deep.toLowerCase() !== title.toLowerCase();
}

/**
 * Authoring UI: location line only when there is a specific location and it is not redundant with the title.
 *
 * @param {{ has_specific_location?: boolean, ebook?: { title?: string|null }, deep_link_title?: string|null }|null|undefined} row
 * @returns {boolean}
 */
export function shouldShowDeepLinkLocationLine(row) {
    if (!row?.has_specific_location) {
        return false;
    }
    return shouldShowDistinctDeepLinkTitle(row);
}
